import { RNG } from "rot-js";
import { logInDev } from "../../../debug";
import { Graph, GraphNode } from "./graphUtils";

type LeafInfo = [number, GraphNode, number];

export const pruneLeafs = (rng: typeof RNG, maxDepth: number, graph: Graph) => {
  const queue: LeafInfo[] = [];
  let room: GraphNode, i: number, depth: number;
  for ([i, room] of graph.entries()) {
    if (room.adj.length === 1) {
      queue.push([i, room, 0]);
    }
  }

  let next: LeafInfo | undefined;
  // eslint-disable-next-line no-cond-assign
  while ((next = queue.pop())) {
    [i, room, depth] = next;
    graph.delete(i);
    const adjRoom = graph.get(room.adj[0]);
    if (adjRoom) {
      adjRoom.adj = adjRoom.adj.filter((j) => j !== i);
      if (adjRoom.adj.length === 1 && depth <= maxDepth) {
        queue.push([room.adj[0], adjRoom, depth + 1]);
      }
    } else {
      logInDev(`No Room found for leaf ${room.adj[0]}`);
    }
  }
};

export const raiseLeafs = (graph: Graph) => {
  let room: GraphNode, i: number;
  for ([i, room] of graph.entries()) {
    if (room.adj.length === 1) {
      room.z = 2;
    }
  }
};
